var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_12045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.4893C0 6.75729 6.26803 0.489258 14 0.489258C21.732 0.489258 28 6.75729 28 14.4893C28 22.2212 21.732 28.4893 14 28.4893C6.26803 28.4893 0 22.2212 0 14.4893ZM15.4593 22.721V15.1042H17.5618L17.8404 12.4794H15.4593L15.4628 11.1657C15.4628 10.4811 15.5279 10.1143 16.5111 10.1143H17.8256V7.48926H15.7227C13.1968 7.48926 12.3078 8.76256 12.3078 10.9039V12.4797H10.7333V15.1045H12.3078V22.721H15.4593Z",
    fill: "#FFFCF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_12045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.489258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.90adb185f15a38494bc18695825490a1.svg";
export { ForwardRef as ReactComponent };